import React, { useState, useEffect } from 'react';
//import { connect } from 'react-redux';
//import ReactDOM from 'react-dom';
//import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
//import TimeField from 'react-simple-timefield';
//import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
//import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';

import { toast } from 'react-toastify';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem,
  Card,
  CardHeader,
  // CardActions,
  CardContent,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';


//import { areas, groups, statusContracts, typesCompany } from 'common/datas';
import { areas, groups, statusContracts, statusesDevice, typesDevice, meterTypes } from 'common/datas';
import { IsNoU } from 'common/utils';


const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListTimeTitle: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
    width: '150px',
  },
  advertiseDefaultsTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
    //height: '42px',
  },
  registerListItemWideInput: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    //height: '40px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  registerListItemDescriptionTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
    height: '40px',
  },
  registerListItemDescription: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    height: '100px',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RegisterDevice = props => {

  const {
    className,
    openDialog,
    modeRegisterDialog,
    onClickCloseDialog,
    onClickSaveDialog,
    userName,

    type,
    companies,
    devices,
    cars,
    editDevice,
  } = props;

  const classes = useStyles();
  
  const [deviceName, setDeviceName] = useState('');
  const [serial_no, setSerialNo] = useState('');
  const [telecom, setTelecom] = useState('');
  const [sim_number, set_sim_number] = useState('');
  const [sim_mobile, set_sim_mobile] = useState('');
  const [macAddress, setMacAddress] = useState('');
  const [imeiNumber, setImeiNumber] = useState('');

  const [selectedStatus, setSelectedStatus] = useState(statusesDevice[0].label);
  const [selectedInstalled, setSelectedInstalled] = useState(typesDevice[0].label);
  const [selectedCarNumber, setSelectedCarNumber] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('');
  //const [selectedMeter, setSelectedMeter] = useState(meterTypes[0].label);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedMeter, setSelectedMeter] = useState('');
  const [meterBtMac, setmeterBtMac] = useState('');

  const [selected_modem_device_serial_no, set_selected_modem_device_serial_no] = useState('');

  const [description, setDescription] = useState('');

  const handleChangeStatus = event => {
    setSelectedStatus(event.target.value);
  };

  const handleChangeInstalled = event => {
    setSelectedInstalled(event.target.value);
  };

  const handleChangeMeter = event => {
    setSelectedMeter(event.target.value);
  };

  // const handleChangeCarNumber = event => {
  //   setSelectedCarNumber(event.target.value);
  // };

  useEffect(() => {
    //console.log("componentDidMount");

    if (!IsNoU(editDevice))
    {
      setDeviceName(editDevice.name);
      setSerialNo(editDevice.serial_no);
      setSelectedStatus(editDevice.status);
      setSelectedInstalled(editDevice.installed);

      if (type === 'manage') {
        setMacAddress(editDevice.mac);
        setSelectedCarNumber(editDevice.car_number);
        setPhoneNumber(editDevice.phone_number);
        setSelectedCompany(editDevice.company);
        setmeterBtMac(editDevice.meter_bt);
        setSelectedMeter(editDevice.meter_type);
        set_selected_modem_device_serial_no(editDevice.device_serial_no);
      }
      else if (type === 'modem') {
        setTelecom(editDevice.telecom);
        set_sim_number(editDevice.sim_no);
        set_sim_mobile(editDevice.sim_mobile);
        setImeiNumber(editDevice.imei);
      }
      setDescription(editDevice.description);
    }
    else {
      setDeviceName('');
      setSerialNo('');
      setMacAddress('');
      setSelectedStatus('');
      setSelectedInstalled('');
      setmeterBtMac('');

      setTelecom('');
      set_sim_number('');
      set_sim_mobile('');
      setImeiNumber('');
  
      setSelectedCarNumber('');
      setSelectedCompany('');
      setPhoneNumber('');
      setDescription('');
    }

  }, [editDevice]); // empty-array means don't watch for any updates

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              {type === 'manage' ? '디바이스' : type === 'modem' ? '모뎀': ''}
            </Typography>
            <Button autoFocus color="inherit" onClick={() => {

                const newData = {};
                if (type === 'modem') {

                  if (IsNoU(deviceName) || deviceName.length <= 0) {
                    toast("모델명을 입력하세요.");
                    return ;
                  }

                  if (IsNoU(serial_no) || serial_no.length <= 0) {
                    toast("시리얼NO를 입력하세요.");
                    return ;
                  }

                  if (IsNoU(telecom) || telecom.length <= 0) {
                    toast("통신회사를 입력하세요.");
                    return ;
                  }

                  if (IsNoU(selectedStatus) || selectedStatus.length <= 0 || selectedStatus === '전체') {
                    toast("모뎀 현황을 선택하세요.");
                    return ;
                  }

                  if (IsNoU(selectedInstalled) || selectedInstalled.length <= 0 || selectedInstalled === '전체') {
                    toast("모뎀 장착을 선택하세요.");
                    return ;
                  }

                  newData.name = deviceName;
                  newData.serial_no = serial_no;
                  newData.telecom = telecom;
                  newData.imei = imeiNumber;
                  newData.sim_no = sim_number;
                  newData.sim_mobile = sim_mobile;
                  newData.status = selectedStatus;
                  newData.installed = selectedInstalled;
                  newData.device_serial_no = selected_modem_device_serial_no;
                  newData.description = description;
                  newData.reg_user = userName;
                  newData.reg_at = new Date();
                }
                else if (type === 'manage') {

                  if (IsNoU(deviceName) || deviceName.length <= 0) {
                    toast("모델명을 입력하세요.");
                    return ;
                  }

                  if (IsNoU(serial_no) || serial_no.length <= 0) {
                    toast("시리얼No를 입력하세요.");
                    return ;
                  }

                  if (IsNoU(macAddress) || macAddress.length <= 0) {
                    toast("MAC Address를 입력하세요.");
                    return ;
                  }

                  if (IsNoU(selectedStatus) || selectedStatus.length <= 0 || selectedStatus === '전체') {
                    toast("디바이스 현황을 선택하세요.");
                    return ;
                  }

                  if (IsNoU(selectedMeter) || selectedMeter.length <= 0) {
                    toast("미터기 종료를 선택하세요.");
                    return ;
                  }

                  if (IsNoU(selectedInstalled) || selectedInstalled.length <= 0 || selectedInstalled === '전체') {
                    toast("디바이스 장착을 선택하세요.");
                    return ;
                  }

                  newData.name = deviceName;
                  newData.serial_no = serial_no;
                  newData.mac = macAddress;
                  newData.imei = imeiNumber;
                  newData.status = selectedStatus;
                  newData.installed = selectedInstalled;
                  newData.car_number = selectedCarNumber;
                  newData.phone_number = phoneNumber;
                  newData.company = selectedCompany;
                  newData.meter_bt = meterBtMac;
                  newData.meter_type = selectedMeter;
                  newData.description = description;
                  newData.modified_at = new Date();
                }
                
                if (!IsNoU(editDevice))
                  newData.id = editDevice.id;

                onClickSaveDialog(newData);
              }}>
              저장
            </Button>
          </Toolbar>
        </AppBar>

        <List>
          <ListItem>
            <Card
              className={clsx(classes.card_root, className)}
            >
              <CardHeader
                className={classes.card_header}
                title={(type === 'manage' ? '디바이스' : type === 'modem' ? '모뎀': '')+(modeRegisterDialog ? '등록' : '수정')}
                subheader='*표시는 필수 항목'
              />
              <CardContent className={classes.content}>
                <List>
                  <ListItem className={classes.listitem_align}>
                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-campaign-name"
                      label='모델 명'
                      required
                      //variant="outlined" 
                      value={deviceName}
                      onChange={event=> setDeviceName(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-campaign-name"
                      label='시리얼 NO'
                      required
                      //variant="outlined" 
                      value={serial_no}
                      onChange={event=> setSerialNo(event.target.value)}
                      margin="dense"/>

                  </ListItem>
                  <Divider />
                  {type === 'modem' && (
                    <>
                      <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="input-telecom"
                          label='통신회사'
                          required
                          //variant="outlined" 
                          value={telecom}
                          onChange={e=> setTelecom(e.target.value)}
                          margin="dense"/>

                      </ListItem>
                      <Divider />
                      <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="input-imei-number"
                          label='IMEI NO'
                          //variant="outlined" 
                          value={imeiNumber}
                          onChange={e=> setImeiNumber(e.target.value)}
                          margin="dense"/>

                      </ListItem>
                      <Divider />
                      <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="input-sim-number"
                          label='SIM NO'
                          //variant="outlined" 
                          value={sim_number}
                          onChange={e=> set_sim_number(e.target.value)}
                          margin="dense"/>

                      </ListItem>
                      <Divider />
                      <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="input-sim-tel"
                          label='개통번호'
                          //variant="outlined" 
                          value={sim_mobile}
                          onChange={e=> set_sim_mobile(e.target.value)}
                          margin="dense"/>

                      </ListItem>
                      <Divider />
                      <ListItem>
                        <TextField
                          className={classes.registerListItemInput}
                          id="outlined-select-agency"
                          label='모뎀 현황'
                          select
                          required
                          value={selectedStatus}
                          onChange={handleChangeStatus}
                          helperText=""
                          //variant="outlined"
                          margin="dense"
                        >
                          {statusesDevice.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>

                        <Box p={2} />

                        <TextField
                          className={classes.registerListItemInput}
                          id="outlined-select-client"
                          label='모뎀 상태'
                          select
                          required
                          value={selectedInstalled}
                          onChange={handleChangeInstalled}
                          helperText=""
                          //variant="outlined"
                          margin="dense"
                        >
                          {typesDevice.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </ListItem>
                      <ListItem>

                        <Autocomplete
                          id="device_serial-auto"
                          options={devices.map(device => device.serial_no)}
                          style={{ width: 260 }}
                          value={selected_modem_device_serial_no}
                          onChange={(event, newValue) => {
                            //console.log(newValue);
                            if (!IsNoU(newValue) && newValue.length > 0) {
                              const selectedDevice = devices.find(device => (device.serial_no === newValue));
                              if (!IsNoU(selectedDevice)) {
                                set_selected_modem_device_serial_no(selectedDevice.serial_no);
                              }
                              else {
                                set_selected_modem_device_serial_no('');
                              }
                            }
                            else {
                              set_selected_modem_device_serial_no('');
                            }
                          }}
                          // onChange={event=> setSelectedCompany(event.target.value)}
                          renderInput={params => (
                            <TextField {...params} 
                              //variant="outlined" 
                              label='디바이스 시리얼'
                              fullWidth 
                              margin="dense" />
                          )}
                        />

                        </ListItem>
                      <Divider />
                      <ListItem>
                        <TextField 
                          style={{textAlign: 'left'}}
                          className={classes.registerListItemDescription}
                          id="outlined-basic-reg-campaign-name"
                          label='상태변경사유'
                          //variant="outlined" 
                          value={description}
                          onChange={event=> setDescription(event.target.value)}
                          margin="dense"
                          multiline
                          rows={4}
                          />
                      </ListItem>
                      <Divider />
                    <Divider />
                    </>
                  )}
                  {type === 'manage' && (
                    <>
                      <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="input-mac-address"
                          label='MAC Address'
                          required
                          //variant="outlined" 
                          value={macAddress}
                          onChange={event=> setMacAddress(event.target.value)}
                          margin="dense"/>

                      </ListItem>
                      <Divider />

                      {/* <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="outlined-basic-reg-campaign-name"
                          label='IMEI NO'
                          //variant="outlined" 
                          value={imeiNumber}
                          onChange={event=> setImeiNumber(event.target.value)}
                          margin="dense"/>

                     </ListItem>
                    <Divider /> */}
                    <ListItem>
                        <TextField 
                          className={classes.registerListItemWideInput}
                          id="outlined-basic-reg-campaign-name"
                          label='전화 번호'
                          //variant="outlined" 
                          value={phoneNumber}
                          onChange={event=> setPhoneNumber(event.target.value)}
                          margin="dense"/>

                     </ListItem>
                    <Divider />
                    <ListItem>
                      <TextField
                        className={classes.registerListItemInput}
                        id="outlined-select-agency"
                        label='디바이스 현황'
                        select
                        required
                        value={selectedStatus}
                        onChange={handleChangeStatus}
                        helperText=""
                        //variant="outlined"
                        margin="dense"
                      >
                        {statusesDevice.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>

                      <Box p={2} />

                      <TextField
                        className={classes.registerListItemInput}
                        id="outlined-select-client"
                        label='디바이스 상태'
                        select
                        required
                        value={selectedInstalled}
                        onChange={handleChangeInstalled}
                        helperText=""
                        //variant="outlined"
                        margin="dense"
                      >
                        {typesDevice.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </ListItem>
                    <Divider />
                    <ListItem>
                      <Autocomplete
                        id="reg-device-car-number-auto"
                        options={cars.map(car => car.number)}
                        // getOptionLabel={
                        //   option => option.name
                        //   //option => option
                        // }
                        style={{ width: 260 }}
                        value={selectedCarNumber}
                        onChange={(event, newValue) => {
                          //console.log(newValue);
                          if (!IsNoU(newValue) && newValue.length > 0) {
                            const selectedCar = cars.find(car => (car.number === newValue));
                            if (!IsNoU(selectedCar)) {
                              setSelectedCompany(selectedCar.company);
                            }
                            else {
                              setSelectedCompany('');
                            }
                          }
                          else {
                            setSelectedCompany('');
                          }
                          
                          setSelectedCarNumber(newValue);
                        }}
                        // onChange={event=> setSelectedCompany(event.target.value)}
                        renderInput={params => (
                          <TextField {...params} 
                            //variant="outlined" 
                            label='차량번호'
                            fullWidth 
                            margin="dense" />
                        )}
                      />

                      <Box p={2} />

                      <TextField
                        className={classes.registerListItemVolume}
                        id="outlined-select-device-brightness"
                        label='택시회사명'
                        value={selectedCompany}
                        //onChange={event=> setSelectedCompany(event.target.value)}
                        //variant="outlined"
                        disabled={true}
                        margin="dense"
                        helperText="* 차량번호 선택시 자동 선택됩니다"
                      />
                    </ListItem>
                    <Divider />
                    <ListItem>

                        <TextField 
                          className={classes.registerListItemInput}
                          id="outlined-basic-reg-campaign-name"
                          label='미터기 연결 BT MAC'
                          //variant="outlined" 
                          value={meterBtMac}
                          onChange={event=> setmeterBtMac(event.target.value)}
                          margin="dense"/>

                        <Box p={2} />

                      <TextField
                        className={classes.registerListItemInput}
                        id="outlined-select-meter"
                        label='미터기 타입'
                        select
                        required
                        value={selectedMeter}
                        onChange={handleChangeMeter}
                        helperText=""
                        //variant="outlined"
                        margin="dense"
                      >
                        {meterTypes.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>

                      <Box p={2} />

                    </ListItem>
                    <Divider />
                    <ListItem>
                      <TextField 
                        style={{textAlign: 'left'}}
                        className={classes.registerListItemDescription}
                        id="outlined-basic-reg-campaign-name"
                        label='상태변경사유'
                        //variant="outlined" 
                        value={description}
                        onChange={event=> setDescription(event.target.value)}
                        margin="dense"
                        multiline
                        rows={4}
                        />
                    </ListItem>
                    <Divider />
                    </>
                  )}
                </List>
              </CardContent>
            </Card>
          </ListItem>
        </List>
      </Dialog>
    </div>
  );
}



RegisterDevice.propTypes = {
  className: PropTypes.string,
  cars: PropTypes.array.isRequired,
  devices: PropTypes.array.isRequired,
};

RegisterDevice.defaultProps = {
  cars: [],
  devices: [],
};

export default RegisterDevice;